import React from 'react'
import clsx from 'clsx'
import { useTheme } from '@mui/material'

import OverflowTooltip from '../../../atoms/OverflowTooltip'
import MultiDrop from '../../../atoms/MultiselectDropdown'
import FieldCopy from '../FieldCopy'

import { getFilteredOptions } from '../helpers'
import useStyles from '../styles'

const MultiselectDropdownItem = ({ value, classes }) => {
  return <span className={classes.multiDropdownItem}>{value}</span>
}

const MultiselectDropdown = ({
  field,
  value,
  disabled,
  canEdit,
  handleChange,
  handleBlur,
  timelineMode,
  task,
  inputOnly,
  row,
  rowKey,
  parent,
  meta,
  shouldFilter,
  inTable
}) => {
  const theme = useTheme()

  const [startingValue, setStartingValue] = React.useState('')
  const [changeAlignment, setChangeAlignment] = React.useState(false)
  const [hovering, setHovering] = React.useState(false)

  const options = React.useMemo(() => {
    if (field.options) return field.options ?? []

    const opts = field.config?.options ?? []

    if (!shouldFilter) {
      return opts.map(opt => opt.val)
    }

    return getFilteredOptions(opts, meta).map(opt => opt.val)
  }, [field, shouldFilter, meta])
  const vals = React.useMemo(
    () => (value ?? '').split('|').filter(Boolean),
    [value]
  )
  const ref = React.useRef(null)
  React.useEffect(() => {
    if (ref.current && ref.current.clientHeight > 35 && timelineMode) {
      setChangeAlignment(true)
    } else {
      setChangeAlignment(false)
    }
  }, [vals, ref, timelineMode])

  const classes = useStyles({
    readOnly: disabled,
    multiSelectTimelineVariant: timelineMode,
    changeAlignment,
    task,
    inputOnly,
    inTable
  })

  return (
    <div
      ref={ref}
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      className={clsx(
        classes.dropdownRoot,
        classes.fieldInputRoot,
        'cf-input-root'
      )}
    >
      {!inputOnly && (
        <OverflowTooltip
          text={field.description}
          className={clsx(classes.label, 'label')}
        >
          {field.title}
        </OverflowTooltip>
      )}

      <FieldCopy
        inTable={inTable}
        visible={hovering}
        text={vals.join(', ')}
        style={{ marginLeft: '0' }}
      />

      <MultiDrop
        wrapperClass={classes.input}
        options={options}
        selected={vals}
        onSelect={opt =>
          handleChange({ target: { value: opt } }, field, row, rowKey, parent)
        }
        hideAdd
        stringOnly
        onOpen={() => setStartingValue(value)}
        onClose={() => {
          if (value !== startingValue) {
            handleBlur && handleBlur()
          }
        }}
        disabled={disabled || !canEdit}
        popperProps={{
          modifiers: [{ name: 'flip' }],
          placement: 'bottom-start'
        }}
      >
        <div>
          <div className={classes.multiDropdownItemContainer}>
            {vals.length === 0 ? (
              <span
                style={{ color: inputOnly ? 'black' : theme.palette.textLight }}
              >
                Select
              </span>
            ) : (
              vals.map((val, idx) => (
                <MultiselectDropdownItem
                  key={`${val}-${idx}`}
                  value={val}
                  classes={classes}
                />
              ))
            )}
          </div>
        </div>
      </MultiDrop>
    </div>
  )
}

export default MultiselectDropdown
